import styled from 'styled-components'
import { fadeIn } from 'common'

export const QuestionsContainer = styled.div`
  animation: ${fadeIn} 0.3s;
  padding-top: 1rem;
  transition: max-height 0.3s linear;
`
